// First-call snippets for the quick start. Each is a complete program for its
// library, calling eth_blockNumber on the chosen chain. `key` is the customer's
// full key when the dashboard has it (right after creating or rotating one),
// else a placeholder.

import { RPC_BASE_URL } from './chains';

export type SnippetLang = 'curl' | 'viem' | 'ethers' | 'web3py';
export type KeyPlacement = 'path' | 'header';

export const SNIPPET_LANGS: { id: SnippetLang; label: string }[] = [
  { id: 'curl', label: 'curl' },
  { id: 'viem', label: 'viem' },
  { id: 'ethers', label: 'ethers' },
  { id: 'web3py', label: 'web3.py' },
];

export function snippet(
  lang: SnippetLang,
  chainId: number,
  key: string,
  placement: KeyPlacement,
): string {
  const pathUrl = `${RPC_BASE_URL}/${chainId}/${key}`;
  const bareUrl = `${RPC_BASE_URL}/${chainId}`;
  const header = placement === 'header';
  switch (lang) {
    case 'curl':
      return header
        ? `curl -s ${bareUrl} \\
  -H 'authorization: Bearer ${key}' \\
  -H 'content-type: application/json' \\
  -d '{"jsonrpc":"2.0","id":1,"method":"eth_blockNumber","params":[]}'`
        : `curl -s ${pathUrl} \\
  -H 'content-type: application/json' \\
  -d '{"jsonrpc":"2.0","id":1,"method":"eth_blockNumber","params":[]}'`;
    case 'viem':
      return header
        ? `import { createPublicClient, http } from 'viem'

const client = createPublicClient({
  transport: http('${bareUrl}', {
    fetchOptions: { headers: { Authorization: 'Bearer ${key}' } },
  }),
})

console.log(await client.getBlockNumber())`
        : `import { createPublicClient, http } from 'viem'

const client = createPublicClient({
  transport: http('${pathUrl}'),
})

console.log(await client.getBlockNumber())`;
    case 'ethers':
      return header
        ? `import { FetchRequest, JsonRpcProvider } from 'ethers'

const request = new FetchRequest('${bareUrl}')
request.setHeader('Authorization', 'Bearer ${key}')
const provider = new JsonRpcProvider(request, ${chainId}, { staticNetwork: true })

console.log(await provider.getBlockNumber())`
        : `import { JsonRpcProvider } from 'ethers'

const provider = new JsonRpcProvider(
  '${pathUrl}',
  ${chainId},
  { staticNetwork: true },
)

console.log(await provider.getBlockNumber())`;
    case 'web3py':
      return header
        ? `from web3 import Web3

w3 = Web3(Web3.HTTPProvider(
    "${bareUrl}",
    request_kwargs={"headers": {"Authorization": "Bearer ${key}"}},
))

print(w3.eth.block_number)`
        : `from web3 import Web3

w3 = Web3(Web3.HTTPProvider("${pathUrl}"))

print(w3.eth.block_number)`;
  }
}
